import * as v from 'valibot';
import { neighborSchema } from './Neighbor';
import { dateStringSchema } from '../../util/valibot';
export const neighborsSchema = v.object({
    fetched_ts: dateStringSchema,
    items: v.array(neighborSchema),
});
